import { render, staticRenderFns } from "./VView.vue?vue&type=template&id=3d85b0ec&scoped=true&"
import script from "./VView.vue?vue&type=script&lang=js&"
export * from "./VView.vue?vue&type=script&lang=js&"
import style0 from "./VView.vue?vue&type=style&index=0&id=3d85b0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85b0ec",
  null
  
)

export default component.exports